import { withLeaflet, Path } from 'react-leaflet';
import { GeoJSON as LeafletGeoJSON } from 'leaflet';
import { pick } from 'lodash';
import PropTypes from 'prop-types';
import { uiColors } from '@leafygreen-ui/palette';

import isObjectShallowEqual from 'utils/is-object-shallow-equal';

class GeoJSONLayer extends Path {
  static propTypes = {
    opacity: PropTypes.number.isRequired,
    featureMap: PropTypes.object.isRequired,
    gradient: PropTypes.object.isRequired,
    theme: PropTypes.string.isRequired,
  };

  createLeafletElement(props) {
    const geoJSONProps = {
      ...props,
      style: this.getStyle.bind(this),
    };

    return new LeafletGeoJSON(props.data, this.getOptions(geoJSONProps));
  }

  componentWillReceiveProps(prevProps) {
    if (this.propsHaveChanged(prevProps)) {
      this.leafletElement.clearLayers();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.propsHaveChanged(prevProps)) {
      this.leafletElement.addData(this.props.data);
    }
  }

  propsHaveChanged(prevProps) {
    const importantProps = ['data', 'opacity', 'featureMap', 'gradient'];

    const restPrevProps = pick(prevProps, importantProps);
    const restProps = pick(this.props, importantProps);

    return !isObjectShallowEqual(restPrevProps, restProps);
  }

  getStyle(feature) {
    const { opacity, featureMap, gradient, theme } = this.props;

    const { id } = feature;
    const { count } = featureMap[id] || {};

    return {
      fillColor: gradient[count] || gradient[undefined],
      weight: 2,
      opacity: 1,
      color: theme === 'dark' ? uiColors.black : 'white',
      dashArray: '3',
      fillOpacity: opacity,
    };
  }

  updateLeafletElement() {
    this.setStyle(this.getStyle);
  }
}

export default withLeaflet(GeoJSONLayer);
